import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import {ProductType} from '../../core/core.types';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'b4a-product-simple-travel-form-airports',
  templateUrl: './simple-travel-form-airports.component.html',
  styleUrls: ['./simple-travel-form-airports.component.css']
})
export class SimpleTravelFormAirportsComponent {

  @Output() sendAirportCopyToParent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendAirportIdForDelete: EventEmitter<any> = new EventEmitter<any> ();
  @Output() sendValidAirport: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendSelectableAirport: EventEmitter<any> = new EventEmitter<any>();

  @Input() index: number;

  @Input() airports: any;

  @Input() fromAirports: any;

  @Input() lenghtOfAirports;

  @Input() selectedAirportTypes;

  aiportFormValid: any[] = [];

  airportForm;

  checkIfValid() {
    this.aiportFormValid = [];

    let len = this.lenghtOfAirports - 1;
    for (let i = 0; i <= len; i++) {
      let index = i.toString();
      document.getElementById('airport-' + index).click();
        this.aiportFormValid.push(this.airportForm)
    }
  }

  displayCurrentValue(event){
    this.airports.price = Math.round(event * 100)
    if(this.airports.price === NaN){
      this.airports.price = 0
    }
  }

  arrayPusher(value) {
    this.aiportFormValid.push(value)
  }

  sendForm(airportForm: boolean) {
    this.airportForm = airportForm;
    this.sendValidAirport.emit(airportForm)
    this.arrayPusher(airportForm)
  }

  copyAuxiliary(auxiliary, index) {
    this.sendAirportCopyToParent.emit({auxiliary, index})
  }

  deleteAuxiliary(airports, index) {
    var r = confirm('Are you sure?');
    if (r === true) {
      this.sendAirportIdForDelete.emit({airports, index})
    }
  }

  SetValueOfPrice(price) {
    if (price !== '') {
      let extractDecimal = price.slice(price.length - 3, price.length - 2)
      if (extractDecimal === ',') {
        let testPrice = price.slice(0, price.length - 3) + price.slice(price.length - 2, price.length)
        this.airports.price = Number(testPrice)
      }else {
        this.airports.price = Number(price * 100)
        this.airports.priceForAdmin += ',00'
      }
    }
  }

  airportChanged(event) {
    for (let airport of this.selectedAirportTypes){
      if (airport.code === this.airports.airport) {
        airport.selectable = true;
      }
      if (airport.code === event) {
        airport.selectable = false;
      }
    }
    this.sendSelectableAirport.emit(this.selectedAirportTypes)
  }
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form-airports/simple-travel-form-airports.component.ts